import React from 'react'

const VideoPlayerContext = React.createContext({
  muted: true,
  setMuted: muted => null
})
export const VideoPlayerProvider = VideoPlayerContext.Provider

export default VideoPlayerContext
